module.exports = __webpack_public_path__ + "static/media/etron_tkz.79c57b48.pdf";